module.exports = __webpack_public_path__ + "img/parttwo_pic6.5584cab6.png";